module.exports = __webpack_public_path__ + "static/media/path2.1b0d212d.svg";